/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import Grid from "@mui/material/Grid";
import ProvenExpertSealStandard from "../../../Provenexpert/ProvenExpertSealStandard";
import provenExpertGold from "../../../../assets/img/logo/proven_expert_empfehlung_2025.png";
import partnersWide from "../../../../assets/img/logo/Bekannt_aus_desktop.png";
import trustSectionStyle from "./trustSectionStyle";
import QuotationCard from "../../../Cards/QuotationCard/QuotationCard";
import Typography from "@mui/material/Typography";
import Carousel from "react-multi-carousel";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Theme } from "@mui/material";

type TrustSectionProps = {
  showCoopPress?: boolean;
};

const TrustSection = ({ showCoopPress = true }: TrustSectionProps) => {
  const responsive = {
    xl: {
      breakpoint: { max: 5000, min: 1920 },
      items: 4,
    },
    lg: {
      breakpoint: { max: 1919, min: 1280 },
      items: 4,
    },
    md: {
      breakpoint: { max: 1279, min: 960 },
      items: 3,
    },
    sm: {
      breakpoint: { max: 959, min: 600 },
      items: 2,
    },
    xs: {
      breakpoint: { max: 599, min: 0 },
      items: 1,
    },
  };

  const allItemsDisplayed = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

  return (
    <Container sx={trustSectionStyle.section}>
      <Box sx={trustSectionStyle.scrollToAnchor} id="kunden">
        {" "}
      </Box>
      <Typography variant={"h2"} sx={trustSectionStyle.heading}>
        Erfahrung aus zehntausenden Mandaten
      </Typography>
      <Grid container alignItems={"stretch"} justifyContent={"center"}>
        <Grid item xs={6} md={3}>
          <Box sx={trustSectionStyle.sealContainer}>
            <ProvenExpertSealStandard marginTop={"0px"} />
          </Box>
        </Grid>
        <Grid item xs={6} md={3}>
          <Box sx={trustSectionStyle.sealContainer}>
            <Box
              component={"img"}
              sx={{ ...trustSectionStyle.logo, ...trustSectionStyle.peGoldLogo }}
              src={provenExpertGold}
              alt={"Proven Expert Empfehlung"}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ paddingTop: "2rem", fontStyle: "italic" }} component={"blockquote"}>
            ”Ich hatte in der Vergangenheit Erfahrungen mit Anwälten, die extrem langsam waren und Monate gebraucht haben, um etwas zu erledigen. Bei euch ist
            das ganz anders: Ihr arbeitet unglaublich schnell und effizient! Als die Gegenseite auf ein Schreiben reagiert hat, habt ihr mich innerhalb von
            Minuten angerufen. Vielen Dank für diesen außergewöhnlichen Service – wirklich beeindruckend!”
          </Typography>
        </Grid>
        <Grid item xs={12} sx={trustSectionStyle.carouselContainer}>
          <Carousel responsive={responsive} draggable={false} arrows={false} autoPlay={false} showDots={!allItemsDisplayed} shouldResetAutoplay={false}>
            <Box sx={trustSectionStyle.carouselCard}>
              <QuotationCard
                text={
                  "Sehr freundlicher und kundenorientierter Service, sehr hilfsbereit und Fragen werden schnell und umfangreich behandelt. Absolut zu empfehlen!"
                }
              />
            </Box>
            <Box sx={trustSectionStyle.carouselCard}>
              <QuotationCard
                text={
                  "Ich hatte immer das Gefühl, persönlich angenommen und ernst genommen zu werden. Herzlichen Dank auch für die unproblematische Abwicklung!"
                }
              />
            </Box>
            <Box sx={trustSectionStyle.carouselCard}>
              <QuotationCard
                text={
                  "Ich habe mich mit meinem Anliegen zu jedem Zeitpunkt gut aufgehoben gefühlt. Der persönliche Kontakt zum Rechtsberater war stets sehr freundlich und unterstützend."
                }
              />
            </Box>
            <Box sx={trustSectionStyle.carouselCard}>
              <QuotationCard
                text={
                  "Es waren nicht nur tolle Telefonate und herzliche Emails, sondern auch ein toller Online-Service mit sehr schnellem Erfolg. Wir sind einfach nur begeistert!"
                }
              />
            </Box>
          </Carousel>
        </Grid>
        {showCoopPress && (
          <>
            <Grid item xs={12} md={8} sx={trustSectionStyle.gridItem}>
              <Box sx={trustSectionStyle.logoContainer}>
                <Box component={"img"} src={partnersWide} alt={"Partner"} sx={trustSectionStyle.logo} />
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
};

export default TrustSection;
